// extracted by mini-css-extract-plugin
export var measureBox = "_br-0";